import {checkNull} from '@/helpers'

export default {
    name: 'quick-search',
    data() {
        return {
            sex: null,
            sex_label: null,
            seeking: null,
            seeking_options: null,
            age: null,
            ages: null,
            province_id: null,
            provinces: null,
            profile_picture: true,
            online: false,
            init_seeking: null,
            nearby_distance: null,
            nearby_distances: null
        }
    },
    props: {
        hasMoreOptions: {
            type: Boolean,
            default: true
        },
        isMobile: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        profile() {
            return this.$store.getters['auth/profile']
        },
        formValues() {
            return this.$store.getters['pub/formValues']
        }
    },
    methods: {
        search(o_queries) {
            let query = {
                sex: this.seeking,
                seeking: this.sex,
                page: 1
            }
            if (this.nearby_distance) {
                query.nearby_distance = this.nearby_distance
            } else {
                query.province_id = this.province_id
            }

            if(this.age && this.age != 'null') query.age = this.age

            if(this.profile_picture) {
                query.profile_picture = 1
            }
            if(this.online) {
                query.online = 1
            }

            localStorage.setItem('base_search', JSON.stringify(query))

            if(typeof o_queries != 'undefined') {
                for (var key in o_queries) {
                    if(o_queries[key] && o_queries[key] != 'null') {
                        query[key] = o_queries[key]
                    }
                }
            }

            this.$router.push({ name: 'user-search-results', query })
        },
        populateProfileValues(values) {
            this.sex = values['sex']
            this.seeking = values['seeking']
            this.init_seeking = values['seeking']
            this.province_id = values['province_id']
            this.nearby_distance = values['nearby_distance'] || null
        },
        populateFormValueValues(values) {
            let o_sex = values['sex'].find(val => val.value == this.sex)
            this.sex_label = checkNull(o_sex) ? o_sex.label : values['sex'][0]['label']
            this.seeking_options = values['seeking']
            this.ages = values['ages']
            this.provinces = values['provinces']
            if (!this.province_id) this.province_id = values['provinces'][0]['id']
            this.nearby_distances = values['nearby_distances'] || null
            if (this.nearby_distances) {
                let defaultDistance = null;
                if (this.nearby_distance) {
                    defaultDistance = this.nearby_distances.find(distance => distance.id === this.nearby_distance) || null
                }
                if (!defaultDistance) {
                    defaultDistance = this.nearby_distances.find(distance => distance.default) || this.nearby_distances[0]
                }
                this.nearby_distance = defaultDistance.id
            }
        },
        customOptionClick(key, val) {
            if( !this.disableGenderOptions(val)) this[key] = val
        },
        disableGenderOptions(seeking) {
            if(this.sex == 'female' && this.init_seeking == 'male') return false
            return (this.sex == 'female') && seeking != this.seeking
        }
    },
    mounted() {
        if(this.profile && this.$store.getters['auth/isAuthenticated']) {
            this.populateProfileValues(this.profile)
        }

        let o_query = localStorage.getItem('base_search')
        if(o_query) {
            o_query = JSON.parse(o_query)
            for (var key in o_query) {
                if(key == 'seeking') {
                    this['sex'] = o_query[key]
                } else if(key == 'sex') {
                    this['seeking'] = o_query[key]
                } else {
                    this[key] = o_query[key]
                }
            }
        }

        if(this.formValues) {
            this.populateFormValueValues(this.formValues)
        }
    },
    watch: {
        profile(values) {
            if(values && this.$store.getters['auth/isAuthenticated']) {
                this.populateProfileValues(values)
                if(this.formValues) this.populateFormValueValues(this.formValues)
            }
        },
        formValues(values) {
            if(values) {
                this.populateFormValueValues(values)
            }
        }
    }
}
